import { render, staticRenderFns } from "./UserShipment.vue?vue&type=template&id=a4fc6c6c&scoped=true"
import script from "./UserShipment.vue?vue&type=script&lang=js"
export * from "./UserShipment.vue?vue&type=script&lang=js"
import style0 from "./UserShipment.vue?vue&type=style&index=0&id=a4fc6c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc6c6c",
  null
  
)

export default component.exports